import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck, CreditCard, Landmark, Crown, Repeat } from 'lucide-react';

const B = process.env.REACT_APP_BACKEND_URL;

export const HeroBackedBadge = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${B}/api/public/reserves`).then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <a href="/reserves" className="inline-flex items-center gap-2 px-4 py-2 bg-slate-900/70 border border-emerald-500/30 rounded-full text-sm text-emerald-300 hover:border-emerald-400 transition-colors max-w-full text-center" data-testid="hero-backed-badge">
      <ShieldCheck className="w-4 h-4" /> {d.fully_backed ? 'Fully backed' : 'Reserves'} · ${Math.round(d.reserves.total_usd).toLocaleString()} reserves vs ${Math.round(d.supply_usd).toLocaleString()} supply
    </a>
  );
};

const FEATURES = [
  { icon: Repeat, title: 'Trade on Uniswap', body: 'BETH/USDC on Base', href: '/#buy' },
  { icon: CreditCard, title: 'Buy by card', body: 'No wallet needed', href: '/#buy' },
  { icon: Landmark, title: 'Proof of reserves', body: 'T-bills + cash, live', href: '/reserves' },
  { icon: Crown, title: 'Tier 2 Hedge Fund', body: '$50M line · funding deals', href: '/pas/signup' },
];

export const HeroFeatureStrip = () => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-4xl mx-auto mt-10" data-testid="hero-feature-strip">
    {FEATURES.map(({ icon: Icon, title, body, href }) => (
      <a key={title} href={href} className="text-left bg-slate-900/60 hover:bg-slate-800/80 border border-slate-700 hover:border-emerald-500/50 rounded-xl p-4 transition-colors" data-testid={`hero-feature-${title.toLowerCase().replace(/\s+/g, '-')}`}>
        <Icon className="w-5 h-5 text-emerald-400 mb-2" />
        <p className="text-sm text-white font-semibold">{title}</p>
        <p className="text-[11px] text-slate-400">{body}</p>
      </a>
    ))}
  </div>
);
